import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { ChevronRight, ArrowLeft } from 'lucide-react';
interface Slide7Props {
  onNavigate: (slide: number) => void;
}
export function Slide7({
  onNavigate
}: Slide7Props) {
  const menuItems = [{
    title: "CONTACT ROCHE CÔTE D'IVOIRE",
    slide: 9
  }, {
    title: 'PRESCRIBING INFORMATION',
    slide: 11
  }, {
    title: 'PREGNANCY CONSIDERATIONS',
    slide: 10
  }];
  return <SlideLayout onBack={() => onNavigate(2)} data-id="element-221">
      <div className="w-full max-w-4xl mx-auto space-y-8" data-id="element-222">
        <div className="space-y-2" data-id="element-223">
          <h1 className="text-4xl font-bold text-white text-center uppercase" data-id="element-224">
            ADDITIONAL RESOURCES
          </h1>
          <p className="text-lg text-white/80 text-center" data-id="element-225">
            SELECT A TOPIC TO LEARN MORE:
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4" data-id="element-226">
          {menuItems.map((item, index) => <button key={index} onClick={() => onNavigate(item.slide)} className="frosted-card rounded-xl p-6 hover:bg-white/25 transition-all duration-300 hover:shadow-xl group flex items-center justify-between" data-id="element-227">
              <span className="text-xl font-bold text-[#1B3A5C] text-left" data-id="element-228">
                {item.title}
              </span>
              <div className="w-10 h-10 flex items-center justify-center" data-id="element-229">
                <ChevronRight className="w-8 h-8 text-[#6B46C1] stroke-[3]" data-id="element-230" />
              </div>
            </button>)}
        </div>
        <div className="flex justify-center pt-4" data-id="element-231">
          <button onClick={() => onNavigate(2)} className="flex items-center gap-2 text-white hover:text-highlight transition-colors duration-200 font-bold text-lg" type="button" data-id="element-232">
            <ArrowLeft className="w-6 h-6" data-id="element-233" />
            BACK TO MAIN MENU
          </button>
        </div>
      </div>
    </SlideLayout>;
}